// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Despesas_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /despesas/salvar
 *
 * Creates or updates a despesa (expense).
 * If despesa_id > 0, updates existing; otherwise creates new.
 */
import { registerContract } from './validate'

export interface Despesas_SalvarInput {
despesa_titulo?: string
despesa_valor?: number
despesa_data_vencimento?: string
despesa_franquia_id?: number
despesa_id?: number
despesa_categoria_id?: number
despesa_status?: number
despesa_data_lancamento?: string
despesa_parcela?: number
despesa_qtd_parcelas?: number
despesa_tipo_mensal?: number
despesa_usuario_id?: string
despesa_payroll_period_id?: number
despesa_plano_conta_id?: number
despesa_generated_from_payroll?: number
despesa_descricao?: string
despesa_observacoes?: string
despesa_nota_fiscal?: string
}

registerContract('Despesas_SalvarInput', {
  despesa_titulo:                 { type: 'string',  required: false },
  despesa_valor:                  { type: 'number',  required: false },
  despesa_data_vencimento:        { type: 'string',  required: false },
  despesa_franquia_id:            { type: 'number',  required: false },
  despesa_id:                     { type: 'number',  required: false },
  despesa_categoria_id:           { type: 'number',  required: false },
  despesa_status:                 { type: 'number',  required: false },
  despesa_data_lancamento:        { type: 'string',  required: false },
  despesa_parcela:                { type: 'number',  required: false },
  despesa_qtd_parcelas:           { type: 'number',  required: false },
  despesa_tipo_mensal:            { type: 'number',  required: false },
  despesa_usuario_id:             { type: 'string',  required: false },
  despesa_payroll_period_id:      { type: 'number',  required: false },
  despesa_plano_conta_id:         { type: 'number',  required: false },
  despesa_generated_from_payroll: { type: 'number',  required: false },
  despesa_descricao:              { type: 'string',  required: false },
  despesa_observacoes:            { type: 'string',  required: false },
  despesa_nota_fiscal:            { type: 'string',  required: false },
})
